import {
  Center,
  Flex,
  Image,
  Text,
} from "@chakra-ui/react";
import Lang from "../../Lang";

export default function Cardvalues({ image, texts }) {
  return (
    <Center>
      <Flex
        w="full"
        h={{ base: 300, md: 500, lg: 500 }}
        overflow={'hidden'}
        direction={'column'}
        pt={{base:4,md:8,xl:10}}
      >
        <Center>
          <Image
            src={image}
            h={{ base: 150, md: 200, xl: 240 }}
            w={{ base: 150, md: 200, xl: 240 }}
          />
        </Center>
        <Text
          align="center"
          pt={{ base: 6, md: 10, lg: 10, xl: 10 }}
          px={{ base: 10, md: 6, lg: 8, xl: 8 }}
          fontSize={{ base: "1.5em", md: "1.7em", lg: "2em", xl: "2em" }}
          className="barlow-black"
        >
          <Lang text={texts} />
        </Text>
      </Flex>
    </Center>

  );
}